<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="loading" v-if="loading">

        </div>
        <div class="container">
          <section class="section01">
            <div class="object01">
              사용자 수정
            </div>
          </section>
          <section class="section02">
            <div class="object01"></div>
            <div class="object02"></div>
            <div class="object03">
              상태
            </div>
            <div class="object04">
              <ul>
                <li class="active">
                  <label>
                    <input type="radio" v-model="status" value="ACTIVE" />
                    <i></i>
                    <span>활성화</span>
                  </label>
                </li>
                <li class="inactive">
                  <label>
                    <input type="radio" v-model="status" value="PASSIVE" />
                    <i></i>
                    <span>비활성화</span>
                  </label>
                </li>
              </ul>
            </div>
            <div class="object05"></div>
            <div class="object06">
              아이디
            </div>
            <div class="object07">
              <input type="text" :value="userId" disabled/>
            </div>
            <div class="object08"></div>
            <div class="object09"></div>
            <div class="object10">
              이름
            </div>
            <div class="object11">
              <input type="text" :placeholder="userName" v-model="userName"/>
            </div>
            <div class="object12"></div>
            <div class="object13">
              휴대폰
            </div>
            <div class="object14">
              <input type="number" class="no-arrow" :placeholder="userPhone" v-model="userPhone"/>
            </div>
            <div class="object15"></div>
            <div class="object16">
              이메일
            </div>
            <div class="object17">
              <input type="text" :placeholder="userEmail" v-model="userEmail"/>
            </div>
            <div class="object18"></div>
            <div class="object19"></div>
            <div class="object20">
              권한
            </div>
            <div class="object21">
              <div class="formSelect" ref="select01" @click="openSelect01">
                <div class="formSelectList">
                  <input type="text" :value="findRoleName(userRole)"  placeholder="권한을 선택하세요." readonly />
                </div>
                <div class="formSelectPopup select01">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="권한을 선택하세요." v-model="searchRoleValue" @keyup="changeRoleValue" />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li v-for="selectUserRole in selectUserRoleList" :key="selectUserRole.roleCode">
                                <label>
                                  <input type="radio" v-model="userRole" :value="selectUserRole.roleCode" />
                                  <input type="checkbox"/>
                                  <i></i>
                                  <span>{{ selectUserRole.roleName }}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="object22"></div>
            <div class="object23"></div>
            <div class="object24">
              담당 골프클럽
            </div>
            <div class="object25">
              <div class="formSelect" ref="select02">
                <div class="formSelectList" @click="openSelect02">
                  <input type="text" :value="findClubName(ccode)" placeholder="담당 골프클럽을 선택하세요." readonly />
                </div>
                <div class="formSelectPopup typeSearch select02">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="검색어를 입력하세요." v-model="searchValue" v-on:keyup="changeSearchValue" />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li v-for="club_info in selectClubInfoList" :key="club_info.ccode" @click="closeSelectAll">
                                <label>
                                  <input type="radio" v-model="ccode" :value="club_info.ccode"/>
                                  <input type="checkbox"/>
                                  <i></i>
                                  <span>{{club_info.club_name}}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="club-list">
                <div v-for="ccode in ccodes" :key="ccode" class="club-item" @click="() => onClubCodeDelete(ccode)">
                  <!-- Club name -->
                  {{ findClubName(ccode) }}
                  <!-- Close icon -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 26 26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                </div>
              </div>
            </div>
            <!-- 툴팁 활성 : tooltipActive -->
            <div class="object26" :class="tooltipActive ? 'tooltipActive' : ''"  @click="openTooltip" ref="tooltip">
              <div class="tooltip">
                [설정 > 골프클럽 관리]에서 활성화 상태로 설정된 골프클럽 목록입니다.
              </div>
            </div>
          </section>
          <section class="section03">
            <div class="object01">
              <button class="cancel" @click="moveMenu('/MA002?account_id=' + accountUserInfo.accountInfo.account_id)">
                취소
              </button>
            </div>
            <div class="object02">
              <!-- 비활성(Attribute) : disabled -->
              <button class="edit" @click="postData" :disabled="!passValidation">
                수정
              </button>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <!-- 확인만(Class) : typeConfirm -->
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertBodyHTML">
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      취소
                    </button>
                    <button class="confirm" @click="closeAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="권한을 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="selectUserRole in selectUserRoleList" :key="selectUserRole.roleCode" @click="closeSelectAll">
                      <label>
                        <input type="radio" v-model="userRole" :value="selectUserRole.roleCode" />
                        <input type="checkbox"/>
                        <i></i>
                        <span>{{ selectUserRole.roleName }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup typeSearch select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="담당 골프클럽을 선택하세요." v-model="searchValue" v-on:keyup="changeSearchValue" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="club_info in selectClubInfoList" :key="club_info.ccode">
                      <label>
                        <input type="radio" v-model="ccode" :value="club_info.ccode" @change="closeSelectAll"/>
                        <input type="checkbox"/>
                        <i></i>
                        <span>{{club_info.club_name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { phoneNumberTester } from '../libs/useRegExp'
import { aplManagerService, clubInfoService } from '../router'
import FooterLayout from './layout/Footer.vue'
import HeaderLayout from './layout/Header.vue'
import LeftLayout from './layout/Left.vue'

export default {
  name: 'MA004',
  data () {
    return {
      userRoleList: [
        {
          roleCode: 'ClubManager',
          roleName: '클럽관리자'
        },
        {
          roleCode: 'AplMaster',
          roleName: 'APL마스터'
        },
        {
          roleCode: 'AplManager',
          roleName: 'APL관리자'
        },
        {
          roleCode: 'AplDeveloper',
          roleName: 'APL개발자'
        },
        {
          roleCode: 'SktDeveloper',
          roleName: 'SKT개발자'
        }
      ],
      loading: true,
      selectUserRoleList: [],
      searchRoleValue: '',
      status: 'ACTIVE',
      userId: '',
      userPw: '',
      userName: '',
      userPhone: '',
      userEmail: '',
      userRole: '테스터',
      ccode: 'cc001',
      ccodes: [],
      active_checked: true,
      not_active_checked: false,
      html_object: {},
      clubInfoList: [],
      accountUserInfo: {
        statusCode: null,
        data: {
          accountInfo: {
            account_id: 1,
            status: '',
            user_id: '',
            user_name: '',
            user_role: '',
            user_phone: '',
            user_email: '',
            ccode: '',
            isrt_id: null,
            isrt_dt: null,
            updt_id: null,
            updt_dt: null
          }
        }
      },
      alertBodyHTML: '',
      callback: null
    }
  },
  created: function () {
  },
  mounted: function () {
    this.loading = true
    this.selectUserRoleList = this.userRoleList
    clubInfoService.getClubInfoList('active').then(response => {
      this.clubInfoList = response.data.clubInfoList
      this.selectClubInfoList = response.data.clubInfoList
      let accountId = this.$route.query.account_id
      this.setData(accountId)
      this.active_checked = true
      this.not_active_checked = false
      document.querySelector('body.type-content').classList.remove('select01Active')
    }).catch(error => {
      console.log('getClubInfoListByStatusActive.err.===>', error)
    })
  },
  computed: {
    passValidation: function () {
      if (!this.status) return false
      if (!this.userId) return false
      if (!this.userName) return false
      if (!this.userRole) return false
      if (((this.userRole === 'ClubManager')) && (!this.ccode)) return false
      if (this.userPhone) return phoneNumberTester().test(this.userPhone)
      return true
    }
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    /**
     * 클럽 코드를 목록에 추가합니다.
     * @param {string} clubCode
     */
    addClubCode(clubCode) {
      this.ccodes = [...this.ccodes, clubCode]
    },
    /**
     * 클럽 코드를 목록에서 제거합니다.
     * @param {string} clubCode
     */
    removeClubCode(clubCode) {
      this.ccodes = this.ccodes.filter((code) => code !== clubCode)
    },
    findClubName: function (ccode) {
      if (this.clubInfoList.find(it => it.ccode === ccode) !== undefined) {
        return this.clubInfoList.find(it => it.ccode === ccode).club_name
      } else {
        return ''
      }
    },
    findRoleName: function (userRole) {
      if (this.userRoleList.find(it => it.roleCode === userRole) !== undefined) {
        return this.userRoleList.find(it => it.roleCode === userRole).roleName
      } else {
        return ''
      }
    },
    changeRoleValue: function () {
      this.selectUserRoleList = this.userRoleList.filter(it => it.roleName.includes(this.searchRoleValue))
    },
    moveMenu: function (path) {
      this.$router.push(path)
    },
    setData: function (accountId) {
      this.loading = true
      aplManagerService.getManagementUserInfo(accountId).then(response => {
        this.accountUserInfo = response.data
        this.userId = this.accountUserInfo.accountInfo.user_id
        this.userName = this.accountUserInfo.accountInfo.user_name
        this.userRole = this.accountUserInfo.accountInfo.user_role
        this.userPhone = this.accountUserInfo.accountInfo.user_phone
        this.userEmail = this.accountUserInfo.accountInfo.user_email
        this.status = this.accountUserInfo.accountInfo.status
        this.ccode = this.accountUserInfo.accountInfo.ccode
        this.loading = false
        this.ccodes = this.accountUserInfo.ccodes
        // console.log('result of MA004:' + this.accountUserInfo)
      }).catch(error => {
        console.log('getManagementUserInfo.err.===>', error)
      })
    },
    postData: function () {
      aplManagerService.putManagementUserModify(this.accountUserInfo.accountInfo.account_id, this.status, this.userName, this.userRole, this.userPhone, this.userEmail, this.ccode, this.ccodes).then(response => {
        // console.log('totalNoticeData Called....---------------')
        // console.log('response.data---------------' + response.data)
        this.resTotalNotice = response.data
        // console.log(this.resTotalNotice)
        // console.log('RESULT--------->' + this.resTotalNotice.data.noticeList[1].notice.content)
        this.openAlert('수정되었습니다.', function () {
          this.moveMenu('/MA002?account_id=' + this.accountUserInfo.accountInfo.account_id)
        })
      }).catch(error => {
        console.log('getTotalNotice.err.===>', error)
      })
    },
    openAlert: function (html, cb = null) {
      this.alertBodyHTML = html
      this.callback = cb
      document.querySelector('body.type-content').classList.add('alertActive')
    },
    closeAlert: function () {
      this.alertBodyHTML = ''
      document.querySelector('body.type-content').classList.remove('alertActive')
      if (this.callback === null) return
      this.callback()
      this.callback = null
    },

    /**
     * @param {string} clubCode
     */
    onClubCodeDelete(clubCode) {
      this.removeClubCode(clubCode)
    }
  },

  watch: {
    ccode(value) {
      const isIncluded = this.ccodes.includes(value)
      if (!isIncluded) this.addClubCode(value)
    }
  }
}
</script>

<style scoped>
.object25 {
  display: flex;
  align-items: center;
  gap: 20px;
}

.club-list {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.7);
}

.club-list .club-item {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 4px 6px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MA004.vue